import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import { getPortalPasswordStatus, setPortalPassword } from "../services/api";
import "../styles/ProfilePage.css";

function ProfilePage({ dealer, onLogout }) {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    let cancelled = false;
    getPortalPasswordStatus()
      .then((data) => !cancelled && setStatus(data))
      .catch((error) => !cancelled && setMessage(error.message || "Unable to load password settings."))
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, []);

  const submitPassword = async (event) => {
    event.preventDefault();
    setMessage("");
    if (newPassword.length < 8 || newPassword.length > 128) {
      setMessage("Use a password between 8 and 128 characters.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setMessage("The passwords do not match.");
      return;
    }
    try {
      setSaving(true);
      await setPortalPassword(newPassword);
      setStatus((current) => ({ ...current, hasPassword: true }));
      setNewPassword("");
      setConfirmPassword("");
      setMessage("Your portal password has been saved.");
    } catch (error) {
      setMessage(error.message || "Unable to save password.");
    } finally {
      setSaving(false);
    }
  };

  const signOut = async () => {
    if (onLogout) await onLogout();
  };

  return (
    <div className="profile-page">
      <PageHeader
        title="Profile"
        showLogo
        actions={<button type="button" className="profile-logout" onClick={signOut}>Logout</button>}
      />
      <main className="profile-content">
        <section className="profile-card">
          <div className="profile-section-heading">
            <h2>Account details</h2>
            <p>Your dealer portal profile</p>
          </div>
          <dl className="profile-details">
            <div><dt>Account</dt><dd>{dealer?.accountName || "—"}</dd></div>
            <div><dt>Login mobile</dt><dd>{dealer?.mobile || "—"}</dd></div>
          </dl>
        </section>

        <section className="profile-card">
          <div className="profile-section-heading">
            <h2>Password</h2>
            <p>Use a password to sign in on a computer, or continue using OTP whenever you prefer.</p>
          </div>
          {loading ? <p className="profile-muted">Loading password settings…</p> : status?.canManage ? (
            <>
              {!status.canSetNow ? (
                <div className="profile-otp-note">
                  <p>For security, password setup or changes require a recent OTP sign-in.</p>
                  <button type="button" onClick={signOut}>Sign out and continue with OTP</button>
                </div>
              ) : (
                <form className="profile-password-form" onSubmit={submitPassword}>
                  <label>
                    {status.hasPassword ? "New password" : "Create password"}
                    <input
                      type="password"
                      autoComplete="new-password"
                      minLength={8}
                      maxLength={128}
                      value={newPassword}
                      onChange={(event) => setNewPassword(event.target.value)}
                      required
                    />
                  </label>
                  <label>
                    Confirm password
                    <input
                      type="password"
                      autoComplete="new-password"
                      minLength={8}
                      maxLength={128}
                      value={confirmPassword}
                      onChange={(event) => setConfirmPassword(event.target.value)}
                      required
                    />
                  </label>
                  <button type="submit" disabled={saving}>{saving ? "Saving…" : status.hasPassword ? "Change password" : "Set password"}</button>
                </form>
              )}
            </>
          ) : (
            <p className="profile-muted">Only the main dealer account can manage the shared portal password.</p>
          )}
          {message && <p className="profile-message" role="status">{message}</p>}
        </section>
      </main>
    </div>
  );
}

export default ProfilePage;
